import type { ReactNode } from 'react';
import { IC, Svg } from '../art/icons.js';
import { useNav } from '../lib/router.js';

/** The catering section's own header: back to the app, the title, and the New order / Your orders / Help tabs. */
export function CaterHeader({ tab, live }: { tab: 'new' | 'orders' | 'help'; live?: number | undefined }) {
  const { navigate } = useNav();
  return (
    <>
      <div className="chead">
        <button type="button" className="round" onClick={() => navigate('/', { root: true })} aria-label="Back to the app"><Svg html={IC.back} /></button>
        <span className="grow col" style={{ gap: 0 }}><span className="spin-eyebrow" style={{ letterSpacing: '.16em' }}>Tikkas</span><b className="ctitle">Catering</b></span>
      </div>
      <div className="ctabs" role="tablist">
        <button type="button" role="tab" aria-selected={tab === 'new'} onClick={() => navigate('/catering', { root: true })}>New order</button>
        <button type="button" role="tab" aria-selected={tab === 'orders'} onClick={() => navigate('/catering/orders', { root: true })}>Your orders{live ? <i>{live}</i> : null}</button>
        <button type="button" role="tab" aria-selected={tab === 'help'} onClick={() => navigate('/catering/help', { root: true })}>Help</button>
      </div>
    </>
  );
}

export function Step({ n, title, done, sub, children }: { n: number; title: string; done: boolean; sub?: string | undefined; children: ReactNode }) {
  return (
    <section className={`cstep ${done ? 'done' : ''}`}>
      <div className="cshead"><span className="csn">{done ? <Svg html={IC.tick} /> : n}</span><span className="grow col" style={{ gap: 1 }}><h2 className="h3">{title}</h2>{sub ? <span className="small muted">{sub}</span> : null}</span></div>
      {children}
    </section>
  );
}

export function Stepper({ value, min = 0, max = 500, onChange, label }: { value: number; min?: number; max?: number; onChange: (v: number) => void; label: string }) {
  return (
    <span className="cstep2">
      <button type="button" disabled={value <= min} onClick={() => onChange(Math.max(min, value - 1))} aria-label={`Fewer ${label}`}>−</button>
      <b>{value}</b>
      <button type="button" disabled={value >= max} onClick={() => onChange(Math.min(max, value + 1))} aria-label={`More ${label}`}>+</button>
    </span>
  );
}

export function Field({ label, children, span2 }: { label: string; children: ReactNode; span2?: boolean }) {
  return <label className={span2 ? 'span2' : undefined}>{label}{children}</label>;
}
